import React from 'react';
import Icon from './Icon';
import './Checkbox.css';

/**
 * The Bridge Checkbox (1116:11817), as the Navy Phase 0 handoff builds it: an
 * 18 box in a 24 target, a 1px input-rule border and a 14 Bold check. Checked
 * keeps the white box and draws the check; it does not fill. Hover only
 * previews the check in icon-grey and the border never changes; focus rings
 * the box (ResUI Design Decisions, Component states). Disabled is opacity-60.
 *
 * Named by `children` (a visible label beside it) or by `ariaLabel`.
 */
function Checkbox({ checked, onChange, ariaLabel, ariaDescribedBy, disabled = false, id, children }) {
  return (
    <label className={`resui-check${children ? ' resui-check--labelled' : ''}`}>
      <input
        id={id}
        type="checkbox"
        className="resui-check-input"
        checked={checked}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-describedby={ariaDescribedBy}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="resui-check-target" aria-hidden="true">
        <span className="resui-check-box"><Icon name="check" size={14} /></span>
      </span>
      {children && <span className="resui-check-label">{children}</span>}
    </label>
  );
}

export default Checkbox;
